module.exports = __webpack_public_path__ + "static/img/hardCT2.c15d7af2.png";